import React from "react";

/* Result format is [..][D]ABC — counted from the END: last digit C, then B, then A, the one before A is D; any earlier digits are unlabelled. */
export const POS_COLORS = { D: "#7C3AED", A: "#DC2626", B: "#2563EB", C: "#16A34A" };
export const POS_ALL = ["Z", "X", "D", "A", "B", "C"]; // counted from the END: C B A D X Z (4D = DABC · 5D = XDABC · 6D = ZXDABC)
export const posLabels = (num) => { const n = String(num || "").length; const tail = POS_ALL.slice(Math.max(0, POS_ALL.length - n)); return [...Array(Math.max(0, n - POS_ALL.length)).fill(""), ...tail]; };

/* Which result digits a ticket is checked against (for A/B/C singles & doubles). */
export function boardPositions(boardType) {
  return { A: ["A"], B: ["B"], C: ["C"], AB: ["A", "B"], BC: ["B", "C"], AC: ["A", "C"], ALL: ["A", "B", "C"] }[boardType] || [];
}
export function resultPart(result, boardType) {
  const r = String(result || ""); if (r.length < 3) return "";
  const abc = r.slice(-3), m = { A: abc[0], B: abc[1], C: abc[2] };
  return boardPositions(boardType).map((p) => m[p]).join("");
}

/* Coloured balls with D · A · B · C letters underneath; `highlight` = positions to ring (e.g. the board the ticket was on). */
export function ResultDigits({ number, size = "w-8 h-8 text-sm", highlight = [], labels = true, className = "", testId }) {
  const digits = String(number || "").split("");
  if (!digits.length) return null;
  const pos = posLabels(number);
  return (
    <div className={`inline-flex items-start gap-1 shrink-0 whitespace-nowrap ${className}`} data-testid={testId || "result-digits"}>
      {digits.map((d, i) => {
        const p = pos[i] || "", hi = p && highlight.includes(p), color = POS_COLORS[p] || "#94A3B8";
        return (
          <div key={i} className="flex flex-col items-center" data-testid={`result-digit-${p || `x${i}`}`}>
            <span className={`inline-flex items-center justify-center rounded-full bg-white border-2 font-mono font-black ${size} ${hi ? "ring-2 ring-offset-1 ring-amber-400 scale-105" : ""} ${p === "D" ? "opacity-80" : !p ? "opacity-50" : ""}`} style={{ borderColor: color, color }}>{d}</span>
            {labels && <span className={`text-[8px] font-black leading-none mt-0.5 ${hi ? "text-amber-600" : "text-slate-500"}`}>{p || "·"}</span>}
          </div>
        );
      })}
    </div>
  );
}

/* One-line verdict for a settled single/double ticket: "A board · 6 matched" / "A = 6, you had 0". */
export function TicketVerdict({ bet, ta }) {
  const positions = boardPositions(bet.board_type);
  if (!positions.length || !bet.result_number || !["won", "lost"].includes(bet.status)) return null;
  const part = resultPart(bet.result_number, bet.board_type), label = positions.join("");
  const won = bet.status === "won";
  return (
    <div className={`mt-2 rounded-lg px-2.5 py-1.5 text-[11px] flex items-center gap-2 flex-wrap ${won ? "bg-emerald-50 text-emerald-800" : "bg-slate-50 text-slate-600"}`} data-testid={`bet-verdict-${bet.id}`}>
      <ResultDigits number={bet.result_number} size="w-5 h-5 text-[10px]" highlight={positions} labels />
      <span>
        {won ? <><b>{label} {ta ? "போர்டு" : "board"} · {bet.number} {ta ? "பொருந்தியது" : "matched"}</b></>
          : <><b>{label} = {part}</b> · {ta ? "உங்கள் எண்" : "you had"} {bet.number}</>}
      </span>
    </div>
  );
}
